import axios from 'axios'
import {store} from '../lib/store'

export const api = {
	debug: false,
	path: function() {
		let protocol = window.location.protocol	// 'http:' или 'https:'

		return protocol + '//api-research.ifk-hm.com/'
	},
	checkLocal: function() {
		if (store.state.token && store.state.token.exp) {
			var exp = store.state.token.exp
		}
		else {
			return false
		}

		let time = parseInt(new Date().getTime()/1000)

		if (time > exp) {
			return false
		}
		else {
			return true
		}
	},
	all: function(...args) {
		return axios.all(...args)
	},
	spread: function(...args) {
		return axios.spread(...args)
	},
	post: function(...args) {
		if (this.debug) {
			console.log('>> api ' + args[0])
			if (args[1]) console.log(args[1])
			console.log('------')
		}

		axios.defaults.baseURL = this.path()

		// перед каждым запросом читаем токен из localStorage
		// т.к. в соседней вкладке могли обновить токены в localStorage
		// и сделать хранимые в store токены недействительными

		if (store.getters.tokenReadTime < Math.floor(Date.now() / 1000) - 60) {
			store.commit('getTokenFromStorage')
		}

		if (!this.checkLocal()) {
			axios.defaults.headers.common['authorization'] = 'expired';
		}

		if (args[1] instanceof FormData) {
			args.push({
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
		}

		return axios.post(...args)
		.then(response => {
			if (this.debug) {
				console.log('<< api ' + args[0])
				if (args[1]) console.log(args[1])
				console.log(response.data)
				console.log('------')
			}

			if (response.data.token !== undefined) {
				if (this.debug) console.log('-- update token')
				store.commit('updateToken', response.data.token)
				delete response.token
			}

			if (!response.data) {
				throw new Error('Server did not reply')
			}

			if (typeof response.data.success == 'undefined') {
				throw new Error(response.data)
			}

			if (!response.data.success) {
				if (this.debug) console.log('-- response error')
				if (this.debug) console.log('-- ' + response.data.error)

				if (response.data.error == 'Unauthorized') {
					if (this.debug) console.log('-- logout')
					store.commit('authLogout')
				}
				else if (response.data.error) {
					throw new Error(response.data.error)
				}
				else {
					throw new Error('Неизвестная ошибка')
				}
			}

			else {
				return response
			}
		})
		.catch(error => {
			if (error.message == 'Network Error') {
				store.dispatch('dialogNotify', {
					title: 'Проблемы с соединением',
					message: '<p>Похоже, наблюдаются проблемы с соединением с интернетом</p>',
					duration: 60000
				})
				if (this.debug) {
					console.log(error)
					console.log(error.response)
					console.log(error.request)
					console.log(error.message)
				}
			}
			else {
				store.dispatch('dialogNotify', {
					title: 'Ошибка',
					message: '<p>Address: ' + args[0] + '</p><p>' + error.message + '</p>'
				})
				throw new Error(error.message)
			}
		})
	}
}
